import postbanneimmhg from "../../../Images/postbanneimmhg.png";

const PostSummary = ({ data, onOpen }) => {
    const truncate = (text = "", limit = 150) => text.length > limit ? text.slice(0, limit) + "..." : text;
    return (
        <div className='col-md-12 p-2 mt-2 mb-2 border rounded-3'>
            <div className='row'>
                <div className='col-md-6 ' style={{ cursor: "pointer" }} onClick={onOpen}>
                    <img src={data?.file || postbanneimmhg} alt={data?.subject || "Neoo Business post image"} className='img-fluid' />
                </div>
                <div className='col-md-6' >
                    <p className='producttdescttxpppyip' style={{ font: "500 17px / 20px Roboto", marginBottom: "3px", cursor: "pointer" }} onClick={onOpen}>{data?.subject || "Neoo Business post subject"}</p>
                    <p className='producttdescttxpppyip'>{truncate(data?.description || "Neoo Business post description")}</p>
                </div>
            </div>
        </div>
    );
};
export default PostSummary;